import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './theme/globals.css'; // Importer ici le fichier global CSS

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
